import { render, staticRenderFns } from "./ConsignmentIndex.vue?vue&type=template&id=060683c6"
import script from "./ConsignmentIndex.vue?vue&type=script&lang=js"
export * from "./ConsignmentIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports